exports = module.exports = require("../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/promotion-page/promotion-page.component.css
// module id = ../../../../../src/app/promotion-page/promotion-page.component.css
// module chunks = main